/** Demo slots: Mondays & Saturdays only, 2pm & 5pm, up to 3 weeks ahead. */

export const DEMO_BOOKING_WEEKS_AHEAD = 3;
export const DEMO_BOOKING_DAYS_AHEAD = DEMO_BOOKING_WEEKS_AHEAD * 7;

/** 1 = Monday, 6 = Saturday */
export const DEMO_BOOKABLE_WEEKDAYS = new Set([1, 6]);

export const DEMO_MAX_SLOT_SELECTIONS = 2;

export const DEMO_TIME_SLOT_VALUES = ["14:00", "17:00"];

function pad2(n) {
  return String(n).padStart(2, "0");
}

export function toYmd(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function parseYmd(ymd) {
  const [y, m, day] = ymd.split("-").map(Number);
  return new Date(y, m - 1, day);
}

export function startOfToday() {
  const t = new Date();
  return new Date(t.getFullYear(), t.getMonth(), t.getDate());
}

export function maxBookableDate() {
  const end = startOfToday();
  end.setDate(end.getDate() + DEMO_BOOKING_DAYS_AHEAD);
  return end;
}

export function maxBookableYmd() {
  return toYmd(maxBookableDate());
}

export function todayYmd() {
  return toYmd(startOfToday());
}

export function isBookableDemoDay(ymd) {
  const d = parseYmd(ymd);
  const today = startOfToday();
  const max = maxBookableDate();
  if (d.getTime() < today.getTime() || d.getTime() > max.getTime()) {
    return false;
  }
  return DEMO_BOOKABLE_WEEKDAYS.has(d.getDay());
}

export function listBookableDemoDates() {
  const out = [];
  const cursor = startOfToday();
  const max = maxBookableDate();
  const d = new Date(cursor);
  while (d.getTime() <= max.getTime()) {
    if (DEMO_BOOKABLE_WEEKDAYS.has(d.getDay())) {
      out.push(toYmd(d));
    }
    d.setDate(d.getDate() + 1);
  }
  return out;
}

export function isValidDemoTimeSlot(value) {
  return DEMO_TIME_SLOT_VALUES.includes(value);
}

export function slotKey(slot) {
  return `${slot.date}_${slot.time}`;
}

export function formatDemoDateLabel(ymd) {
  return parseYmd(ymd).toLocaleDateString(undefined, {
    weekday: "long",
    month: "short",
    day: "numeric",
  });
}

export function formatDemoTimeLabel(time) {
  if (time === "14:00") return "2:00 PM";
  if (time === "17:00") return "5:00 PM";
  return String(time);
}

export function formatDemoSlotLabel(slot) {
  return `${formatDemoDateLabel(slot.date)} · ${formatDemoTimeLabel(slot.time)}`;
}

export function serializeDemoSlots(slots, timezoneLabel) {
  const slotText = slots.map(formatDemoSlotLabel).join("; ");
  const timePreference = timezoneLabel ? `${slotText} (${timezoneLabel})` : slotText;
  return {
    demoSlots: slots,
    demoDates: slots.map((s) => ({ date: s.date, time: s.time })),
    timePreference,
  };
}
